import React from 'react'
import { Create } from 'react-admin'
import { LOCATION_ARRANGEMENTS_STARTUP } from 'services/api/entities/catalog/location/arrangement'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import LocationForm from './LocationForm'

const LocationCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create
        record={{
          arrangements: LOCATION_ARRANGEMENTS_STARTUP,
        }}
      >
        <LocationForm />
      </Create>
    </SectionWrapper>
  )
}

export default LocationCreate
